import Modal from '../../../components/modal';
import Content from '../../../content';

namespace('IO.Views.FirewallPolicies', function (exports) {
  'use strict';

  var RulesIndexView = IO.Views.FirewallRules.Index,
    Show = Content.extend({
      dom: {
        FIREWALL_RULES: '.firewall-rules',
        JSON_CONTENT: '.json-modal-content',
        JSON_CODE: '.json-code',
        JSON_SHOW_BUTTON: '.show-json-button',
        POLICY_TITLE: 'header > h2',
        SELECT2_FIELD: '.select2select',
        DELETE_BUTTON: '#FirewallPolicy_delete',
        IMPACT_CANCEL: '#impact-form .io-form-action-cancel',
        IMPACT_FORM: '#impact-form',
      },

      events: function () {
        var events = {};

        events['click ' + this.dom.JSON_SHOW_BUTTON] = '_showJSONModal';
        events['click ' + this.dom.DELETE_BUTTON] = '_warnDeletion';
        events['click ' + this.dom.IMPACT_CANCEL] = '_impactCancel';
        return events;
      },

      onDestroy: function () {
        if (this.xmlModal) {
          this.xmlModal.destroy();
        }

        if (this.policyForm) {
          this.policyForm.destroy();
        }

        this.rules.destroy();

        _.each(this.rulesOpened, function (ruleView) {
          ruleView.destroy();
        });
      },

      render: function () {
        var $select = this.$(this.dom.SELECT2_FIELD);

        $select.select2(
          window.select2Defaults({
            acceptNotFound: false,
            allowClear: true,
            placeholder: '',
          }),
        );

        this.rulesOpened = {};
        this.rules = new RulesIndexView({ el: this.dom.FIREWALL_RULES });
        this._parseJSON();
      },

      _warnDeletion: function (e) {
        var url = this.cleanUrl(location.href).split('/'),
          warnModal;

        if (!$(e.target).hasClass('triggered')) {
          e.preventDefault();

          warnModal = new IO.Views.Components.ConfirmationDialog({
            url:
              '/' +
              currentCustomer +
              '/firewalls/' +
              url[url.length - 1] +
              '/impact',
            jst_template: 'firewall_policies/impact', // eslint-disable-line camelcase
            proceedIfDataIsEmpty: true,
            method: 'GET',
            modalWidth: 700,
          });
          warnModal.on('modalContentSet', (el) => {
            if (el.find('.confirmImput').length > 0) {
              el.find('.yes').toggleClass('disabled');
            }
          });

          warnModal.impact().answer(function (proceed) {
            if (proceed) {
              $(e.target).addClass('triggered').trigger('click');
            }
            warnModal.destroy();
          });
          return false;
        }
      },

      _showJSONModal: function (e) {
        e.preventDefault();

        if (!this.xmlModal) {
          this._createModal();
        }

        this.xmlModal.show();
      },

      _createModal: function () {
        var content = this.$(this.dom.JSON_CONTENT).html();

        this.xmlModal = new Modal({ id: 'json-modal', wait: true });
        this.xmlModal.setContent(content);
        this.xmlModal.$el.find('.json').css({ height: 450 });
        this.xmlModal.$el.css({
          marginTop: '0',
          top: '20%',
          height: 520,
        });
      },

      _parseJSON: function () {
        var $json = this.$(this.dom.JSON_CODE),
          jsonContent = $json.text();

        if (jsonContent) {
          $json.html(JSON.stringify(JSON.parse(jsonContent), undefined, 2));
          prettyPrint();
        }
      },

      _successCustom: function () {
        Turbolinks.visit(document.location.href);
      },

      cleanUrl: function (url) {
        return url.split(/[#?]/)[0];
      },

      _impactCancel: function (e) {
        var form = $(this.dom.IMPACT_FORM);

        e.preventDefault();
        form.append('<input name="edit" type="hidden" value="1" />');
        form.submit();
      },
    });

  exports.Show = Show;
});
